"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Inner_1 = require("./Inner");
exports.OsmosysConverter = (_a) => {
    var { run = true, showSpinner = true, steps, conversions, onStop } = _a, props = tslib_1.__rest(_a, ["run", "showSpinner", "steps", "conversions", "onStop"]);
    const stepsMemo = react_1.useMemo(() => {
        var _a;
        return Array.isArray(steps)
            ? steps
            : conversions
                ? (_a = conversions) === null || _a === void 0 ? void 0 : _a.reduce((acc, conversion) => {
                    var _a, _b, _c, _d, _e;
                    return [
                        ...acc,
                        {
                            converterMessage: `Running conversion "${conversion.name}" (${(_b = (_a = conversion) === null || _a === void 0 ? void 0 : _a.steps) === null || _b === void 0 ? void 0 : _b.length} step${((_d = (_c = conversion) === null || _c === void 0 ? void 0 : _c.steps) === null || _d === void 0 ? void 0 : _d.length) === 1 ? 's' : ''})...`,
                            level: 'header',
                        },
                        ...(((_e = conversion) === null || _e === void 0 ? void 0 : _e.steps) || []).sort((stepA, stepB) => stepA.order - stepB.order),
                    ];
                }, []) : [];
    }, [steps, conversions, run]);
    return (react_1.default.createElement(Inner_1.OsmosysConverterInner, Object.assign({ showSpinner: showSpinner, run: run, steps: stepsMemo, onStop: onStop }, props)));
};
//# sourceMappingURL=index.js.map